// src/db.js  —  Todas las operaciones con Firestore
import {
  collection, doc, getDocs, getDoc, addDoc, updateDoc,
  deleteDoc, query, where, orderBy, serverTimestamp
} from 'firebase/firestore';
import { db } from './firebase';

const COL = 'importaciones';

// ── Obtener todas las importaciones ──────────────────────────
export async function getImportaciones() {
  const q = query(collection(db, COL), orderBy('updatedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// ── Obtener una por ID ────────────────────────────────────────
export async function getImportacion(id) {
  const snap = await getDoc(doc(db, COL, id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

// ── Buscar por número de importación (tracking público) ───────
export async function getByNumero(numero) {
  const q = query(
    collection(db, COL),
    where('numeroImportacion', '==', numero.toUpperCase().trim())
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

// ── Crear nueva importación ───────────────────────────────────
export async function createImportacion(data) {
  // Verificar duplicado
  const existe = await getByNumero(data.numeroImportacion);
  if (existe) throw new Error('Ya existe una importación con ese número');

  const ref = await addDoc(collection(db, COL), {
    ...data,
    numeroImportacion: data.numeroImportacion.toUpperCase().trim(),
    status: data.status || 'Pendiente',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return { id: ref.id, ...data };
}

// ── Actualizar importación ────────────────────────────────────
export async function updateImportacion(id, data) {
  const ref = doc(db, COL, id);
  await updateDoc(ref, {
    ...data,
    numeroImportacion: data.numeroImportacion.toUpperCase().trim(),
    updatedAt: serverTimestamp(),
  });
  return { id, ...data };
}

// ── Eliminar importación ──────────────────────────────────────
export async function deleteImportacion(id) {
  await deleteDoc(doc(db, COL, id));
}
